import { BankAccount } from 'APIs/merchants/merchants.types';
import { useMemo } from 'react';
import DataTable, { TableColumn, createTheme } from 'react-data-table-component';

import { TableStyleSettings, TableThemeSettings } from './constants';
import { DataTableContainer, MessageWrapper } from './styles';

createTheme('polarized', TableThemeSettings);

interface Props {
  bankAccountList: Array<BankAccount>;
  selectBankAccount: (bankAccount: BankAccount | null) => void;
}

function BankAccountDataTable({ bankAccountList, selectBankAccount }: Props) {
  const columns: TableColumn<BankAccount>[] = useMemo(
    () => [
      {
        name: 'Account number',
        selector: (row: BankAccount) =>
          'AuBankAccountIdentifier' in row.identifier
            ? row.identifier.AuBankAccountIdentifier.accountNumber
            : 'HkBankAccountIdentifier' in row.identifier
            ? row.identifier.HkBankAccountIdentifier.accountNumber
            : 'HkUsdBankAccountIdentifier' in row.identifier
            ? row.identifier.HkUsdBankAccountIdentifier.accountNumber
            : 'NzBankAccountIdentifier' in row.identifier
            ? row.identifier.NzBankAccountIdentifier.accountNumber
            : 'SgBankAccountIdentifier' in row.identifier
            ? row.identifier.SgBankAccountIdentifier.accountNumber
            : '',
        grow: 2,
      },
      {
        name: 'Account name',
        selector: (row: BankAccount) => row.accountName,
        grow: 2,
      },

      {
        name: 'Bank name',
        selector: (row: BankAccount) => row.bankName,
        grow: 2,
      },
      {
        name: 'Currency',
        cell: (row: BankAccount) => row.currency,
        grow: 1,
        center: true,
      },
      {
        name: 'Primary for currency',
        cell: (row: BankAccount) => (row.isPrimaryForCurrency ? 'Yes' : 'No'),
        grow: 1,
        center: true,
      },
      {
        name: 'Country',
        cell: (row: BankAccount) => row.country,
        grow: 1,
        center: true,
      },
    ],
    [],
  );

  return (
    <DataTableContainer>
      <DataTable
        pagination={false}
        responsive
        columns={columns}
        onRowClicked={(row) => selectBankAccount(row)}
        data={bankAccountList ?? []}
        customStyles={TableStyleSettings}
        theme="polarized"
        className=""
        noDataComponent={
          <MessageWrapper>
            <div>No bank accounts to display</div>
          </MessageWrapper>
        }
        sortServer
        persistTableHead
        defaultSortAsc={false}
      />
    </DataTableContainer>
  );
}

export default BankAccountDataTable;
